export default "__VITE_ASSET__D408fyCx__"